<template>
  <div class="bottle-feature-outer">
    <div class="bottle-feature-display">
      <div class="content-region content-region-1">
        <div class="upper-region">
          <h3 v-if="content.title">
            {{ content.title }}
          </h3>
          <h5 v-if="content.subtitle">
            {{ content.subtitle }}
          </h5>
          <StarsRating
            v-if="content.review"
            :rating="content.review.rating"
            :rating-amount="content.review.reviews"
            row="true"
            class="product-rating"
          />
        </div>
        <div
          v-if="content.description"
          class="description"
        >
          {{ content.description }}
        </div>

        <div
          v-if="content.action.enabled"
          class="actions"
        >
          <HighlightButton
            :url="content.action.linkUrl"
            :title="content.action.linkTitle"
            :button-type="content.action.buttonType"
            :button-style="content.action.buttonStyle"
          />
        </div>
      </div>
      <div class="image-region">
        <standard-image-display
          :alt="content.image.alt"
          :title="content.image.alt"
          :source="content.image.fileStore.presignedURL"
          :object-position="content.image.objectPosition"
          :object-fit="content.image.objectFit"
          lazy-loading="lazy"
          :aspect="content.image.imageAspectRatio"
        />
      </div>
      <div
        v-if="content.awards"
        class="content-region content-region-2"
      >
        <AwardList :items="content.awards" />
      </div>
    </div>
  </div>
</template>

<script>
import StarsRating from './product-star-display.vue'
import StandardImageDisplay from '../grids/standard-image-display.vue'
import HighlightButton from '../grids/button/highlight-button.vue'
import AwardList from './award-list.vue'

export default {
  name: 'product-hero',
  components: {
    StarsRating,
    StandardImageDisplay,
    HighlightButton,
    AwardList
  },
  props: {
    content: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@scss/custom.scss';
.bottle-feature-outer {
    padding:1em;
    @include media-breakpoint-up(md) {
    padding:3.5em 1em;
    }
    height: 100%;
}
.bottle-feature-display {
    --image-scale:1.4;
}
.bottle-feature-display {
    display: flex;
    flex-direction: column;
    position: relative;
    height:100%;
    max-width: 100%;
    margin: 0 auto;
    //padding and gaps
    padding: 1.5em;
    gap: 3em;
    @include media-breakpoint-up(lg) {
        gap: 1em;
        flex-direction: row;
        align-items: center;
    }
    @include media-breakpoint-up(lg) {
        padding: 1em 2.5em;
    }
    @include media-breakpoint-up(xl) {
        padding: 1em 3.5em;
    }

    //stylingm
    background: white;
    border-radius: 12px;
    box-shadow: 0px 0px 20px 0px rgba(0,0,0, .15);
}

/* .bottle-feature-display {
    display: grid;
    grid-template-areas:
        "image-display"
        "main-text"
        "awards";
        @include media-breakpoint-up(lg) {
          grid-template-areas:
          "main-text image-display awards";
        }
  }
 *//*
  .content-region.content-region-1 {
    grid-area: main-text;
  }
  .content-region.content-region-2 {
    grid-area: awards;
  }
  .image-region  {
    grid-area: image-display;
  } */

  .bottle-feature-display {
    @include media-breakpoint-down(md) {
    .image-region{
        order:1;
    }
    .content-region.content-region-1 {
        order:2;
    }
    .content-region.content-region-2 {
        order:3;
    }
}
}
.image-region {
    display: flex;
    width: 100%;
    max-width: 60%;
    @include media-breakpoint-up(sm) {
    max-width: 80%;
    }
    margin:0 auto;

    @include media-breakpoint-up(md) {
    max-width:50%;
    min-width:50%;
    }
    @include media-breakpoint-up(lg) {
    max-width:30%;
    min-width:30%;
    transform: scale(var(--image-scale));
    }
    @include media-breakpoint-up(xl) {
    max-width:25%;
    min-width:25%;
    }
    position: relative;

    .image-container{
        padding:1em;
        @include media-breakpoint-up(lg) {
        padding:2em;
        }
    }
}

.content-region {
    display: flex;
    flex-direction: column;
    word-break: break-word;
    gap:1em;
    width:100%;
}

.content-region-1 {
    @include media-breakpoint-up(lg) {
    margin-right: 1em;
    }
}
.content-region-2 {
    @include media-breakpoint-up(lg) {
    margin-left: 1em;
    }
}
.star-rating-display {
    display:flex;
}
.actions {
    display:flex;
}
.description {
    font-size:.867em;
}
</style>
